import styles from '../styles/sideicon.module.scss'

export const GuildSideBar = ({ guild, selected }: any) => {
    const url = `https://cdn.discordapp.com/icons/${guild.id}/${guild.icon}`
    let guild_url = guild.icon ? url : '/dreamvast.png'
    return(
        <div className={styles.container} data-color={selected ? "yes" :"no"} title={guild.name}>
            <img
                src={guild_url} 
                className={styles.sidebar_image} 
                alt={guild.name}
            />
        </div>
    )
}